import { Box, Checkbox as MuiCheckbox, Tooltip } from "@mui/material";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import RadioButtonUncheckedRoundedIcon from "@mui/icons-material/RadioButtonUncheckedRounded";
import { StyledTableCell } from "../style";

export default function Checkbox({
  id,
  content,
  style,
  onChange,
  disabled,
  tooltipOn,
  tooltipOff,
}) {
  const checked = !!content;
  const tip = checked ? tooltipOn : tooltipOff;
  const checkbox = (
    <MuiCheckbox
      size="small"
      checked={checked}
      disabled={disabled}
      onChange={(e) => onChange?.(id, e.target.checked, content)}
      onClick={(e) => e.stopPropagation()}
      icon={
        <RadioButtonUncheckedRoundedIcon
          fontSize="small"
          sx={{ color: "action.disabled" }}
        />
      }
      checkedIcon={
        <CheckCircleRoundedIcon
          fontSize="small"
          sx={{ color: "success.main" }}
        />
      }
      sx={{
        p: 0.75,
        borderRadius: "50%",
        "&:hover": { backgroundColor: "action.hover" },
      }}
    />
  );
  return (
    <StyledTableCell style={style} align="center">
      <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
        {tip ? (
          <Tooltip title={tip} arrow placement="top">
            <span>{checkbox}</span>
          </Tooltip>
        ) : (
          checkbox
        )}
      </Box>
    </StyledTableCell>
  );
}
